<template>
    <div>

      <hr>
      <h2 class="my-4">{{ $t("doctor.online_appointment.selection_subheadings") }}</h2>
      <div class="grid grid-cols-2 gap-4 lg:grid-cols-5">
          <div class="col-span-5 sm:col-span-2 bg-primaryBg rounded-md p-4">
              
              
                <ClientOnly fallback-tag="span" fallback="Loading Scheduler...">
  
                    <LazyDoctorSchedulerModal />
                    <DatePicker v-model.string="selectedApptDate" :model-value="'MM/DD/YYYY'" :masks="{modelValue:'MM/DD/YYYY'}" :attributes="calendarAttr" :min-date="(new Date()).setDate((new Date()).getDate() + min_date_offset)" :max-date="(new Date()).setDate((new Date()).getDate() + max_date_offset)" locale="zh-Hans" timezone="America/New_York" transparent borderless is-required expanded :color="'primary'"/>
  
                </ClientOnly>
          </div>
  
          <div class="col-span-5 sm:col-span-3">
              <DoctorSchedulerTimePicker/>
          </div>
            
      </div>
  
      
        <hr class="mt-6">
    </div>
  </template>
  
  <script setup>
  import { Calendar, DatePicker } from 'v-calendar'
  import { onMounted } from 'vue'
  import { useFlowbite } from '~/composables/useFlowbite';

  // initialize components based on data attribute selectors
  onMounted(() => {
    useFlowbite(() => {
      initFlowbite();
    })
  })

  const {
    doctorDetails
  } = useSearch()
  const min_date_offset = 2
  const max_date_offset = 90
  const {
    tergetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest, selectedApptDate, SetSelectedApptDate, getAppointmentSlots, AppointmentSlots, setAppointmentSlots, selectedAppointmentSlot, setSelectedAppointmentSlot, setModalShow

  } = usePatientAppointmentRequest()

  var calendarAttr = ref([
    {
      dates: (new Date()).setDate((new Date()).getDate() + min_date_offset)
    }
  ])
  onMounted(async () => {
    setModalShow(false)
    if (!selectedApptDate.value) {
      // If the selectedApptDate is not set, set it to the the first available date so that the server can populate slots
      const target_date = ((new Date()).setDate((new Date()).getDate() + min_date_offset))
      const target_date_obj = new Date(target_date)
      const target_date_str = ('0' + (target_date_obj.getMonth() + 1)).slice(-2) + '/'
        + ('0' + target_date_obj.getDate()).slice(-2) + '/'
        + target_date_obj.getFullYear();

      // This should trigger watch() to get the slots
      selectedApptDate.value = target_date_str


      console.log(`Target Appointment Date Initialized to : ${target_date_str}`)
    }
  })





  </script>